// @ts-check
import React, { useState } from 'react';
import { Drawer, DrawerHeader } from 'preferral-ui/components/Drawer';
import { PillTab, PillTabs } from 'preferral-ui/components/PillTabs';
import { ImportQuestionnaireJSONForm } from './ImportQuestionnaireJSONForm';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { CopyButton } from 'preferral-ui/components/CopyButton';

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  sections: any[];
  onImport(sections: any[]): void;
}} ImportExportJSONDrawerProps */

/** @type { React.FC<ImportExportJSONDrawerProps> } */
export const ImportExportJSONDrawer = (props) => {
  const { isOpen, onClose, sections, onImport } = props;
  const [activeTab, setActiveTab] = useState('EXPORT');

  return (
    <Drawer
      className="_ImportExportJSONDrawer"
      isOpen={isOpen}
      onRequestClose={onClose}
      width="md"
    >
      <DrawerHeader
        icon="copy"
        title="Import/Export Sections"
        onClose={onClose}
      />

      <div className="p-4">
        <div className="flex justify-center mb-4">
          <PillTabs activeTab={activeTab} onChange={setActiveTab}>
            <PillTab tab="EXPORT">Export</PillTab>
            <PillTab tab="IMPORT">Import</PillTab>
          </PillTabs>
        </div>

        {activeTab === 'EXPORT' ? (
          <>
            <div className="flex flex-col space-y-2">
              <div className="text-center">
                <CopyButton text={JSON.stringify(sections, null, 2)} size="sm">
                  Click to Copy
                </CopyButton>
              </div>
              <pre className="shodow-inner flex-grow p-1 font-mono text-xs text-green-300 bg-gray-800 rounded-lg">
                {JSON.stringify(sections, null, 2)}
              </pre>
            </div>
          </>
        ) : (
          <ImportQuestionnaireJSONForm
            onSave={(sections) => {
              onImport(sections);
              FlashMessageActions.flashSuccess({
                message: 'Questionnaire sections imported!',
              });
              onClose();
            }}
          />
        )}
      </div>
    </Drawer>
  );
};
